import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  RpaConnectorDetail
} from 'app/rpa-bots/core/rpa-details-details.types';
import {
  EListSelectionStatus,
  RpaBotType
} from 'app/rpa-bots/core/rpa-bots-type.enum';
import { BotsListComponent } from 'app/rpa-bots/shared/bots-list/bots-list.component';
import {
  UpdateUIPathConn,
  getCurrentUIPathConn
} from 'app/rpa-bots/uipath/store/actions/rpa-uipath-conn.actions';
import {
  UpdateAutomationAnywhereConn,
  GetCurrentAutomationAnywhereConn
} from 'app/rpa-bots/automation-anywhere/store/actions/rpa-automation-anywhere-conn.actions';
import {
  UpdateBluePrismConn,
  getCurrentBluePrismConn
} from 'app/rpa-bots/blue-prism/store/actions/rpa-blueprism-conn.actions';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SavePendingChangesComponent } from 'app/shared/components/save-pending-changes/save-pending-changes.component';
import { IAppState } from 'app/IAppState';
import { IRPAWrapperDetails, IRpaConnectionAutomationAnywhere, IRpaConnectionBluePrism, IRpaConnectionUiPath } from './IRpaBots';

@Injectable({
  providedIn: 'root'
})
export class PendingChangesService {
  private _wrapperDeail: IRPAWrapperDetails;
  private _connectorListComponent: BotsListComponent;
  private _connectorType: RpaBotType;
  private _store: Store<IAppState>;
  private _modalRef: BzgModalRef;

  selectedConnector: RpaConnectorDetail;
  nextConnector: RpaConnectorDetail;
  toSaveConnector: RpaConnectorDetail;
  listSelectionStatus: EListSelectionStatus;

  constructor(private _modalService: BzgModalService) {
    this.listSelectionStatus = EListSelectionStatus.unselect;
  }

  initialize(
    store: Store<IAppState>,
    wrapperDetail: IRPAWrapperDetails,
    connectorListComponent: BotsListComponent,
    connectorType: RpaBotType,
    listSelectionStatus?: EListSelectionStatus,
  ) {
    this._store = store;
    this._wrapperDeail = wrapperDetail;
    this.listSelectionStatus = listSelectionStatus;
    this._connectorListComponent = connectorListComponent;
    this._connectorType = connectorType;
  }

  check() {
    (this._wrapperDeail.hasPendingChanges && this._wrapperDeail.isConnectorValid)
      ? this.dialogPendingChanges()
      : this.pendingChangesManager('continue');
  }

  dialogPendingChanges() {
    this._modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
    this._modalRef.afterClosed().subscribe(result => {
      this.pendingChangesManager(result.action);
    });


  }

  pendingChangesManager(action: string) {
    if (!this._wrapperDeail) {
      return;
    }
    this.toSaveConnector = this._wrapperDeail.modifiedConnector;
    switch (action) {
      case 'save':
        this._updateConnector();
        break;
      case 'dontsave':
      case 'continue':
        this.listSelectionStatus = EListSelectionStatus.select;
        this._connectorListComponent.currentBot = this.nextConnector;
        this.selectedConnector = _.cloneDeep(this.nextConnector);
        this.nextConnector = null;
        this.toSaveConnector = null;
        this._getCurrentConnector();
        break;
      default:
        this._connectorListComponent.currentBot = this.selectedConnector;
        break;
    }
  }

  afterConnectorUpdated(ladingList: boolean) {
    if (
      !ladingList &&
      this.listSelectionStatus === EListSelectionStatus.loading
    ) {
      this._connectorListComponent.currentBot = this.nextConnector;
      this.selectedConnector = _.cloneDeep(this.nextConnector);
      this.nextConnector = null;
      this.toSaveConnector = null;
      this._getCurrentConnector();
      this.listSelectionStatus = EListSelectionStatus.select;
    }
  }

  private _updateConnector() {
    switch (this._connectorType) {
      case RpaBotType.UiPath:
        this._store.dispatch(
          new UpdateUIPathConn(this.toSaveConnector as IRpaConnectionUiPath)
        );
        break;
      case RpaBotType.AutomationAnywhere:
        this._store.dispatch(
          new UpdateAutomationAnywhereConn(this
            .toSaveConnector as IRpaConnectionAutomationAnywhere)
        );
        break;
      case RpaBotType.BluePrism:
        this._store.dispatch(
          new UpdateBluePrismConn(this
            .toSaveConnector as IRpaConnectionBluePrism)
        );
        break;
    }
  }

  private _getCurrentConnector() {
    if (!this.selectedConnector) {
      return;
    }
    switch (this._connectorType) {
      case RpaBotType.UiPath:
        this._store.dispatch(
          new getCurrentUIPathConn(
            (this.selectedConnector as IRpaConnectionUiPath).id
          )
        );
        break;
      case RpaBotType.AutomationAnywhere:
        this._store.dispatch(
          new GetCurrentAutomationAnywhereConn(
            (this.selectedConnector as IRpaConnectionAutomationAnywhere).id
          )
        );
        break;
      case RpaBotType.BluePrism:
        this._store.dispatch(
          new getCurrentBluePrismConn(
            (this.selectedConnector as IRpaConnectionBluePrism).id
          )
        );
        break;
    }
  }
}
